function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.137 3.333C11.472 1.117 9.283-.278 6.993.056 4.703.39 3.003 2.352 3 4.666v.067C1.322 5.074.175 6.631.347 8.335c.172 1.704 1.607 3 3.32 2.998h2c.368 0 .666-.298.666-.666 0-.369-.298-.667-.666-.667h-2c-1.105.008-2.007-.88-2.015-1.985C1.643 6.91 2.532 6.008 3.637 6h.08c.197-.004.383-.088.516-.233.13-.151.184-.352.15-.547-.031-.183-.048-.368-.05-.553.013-1.737 1.356-3.172 3.088-3.3 1.731-.128 3.271 1.094 3.539 2.81.026.183.128.347.28.453.154.103.342.14.523.103.187-.044.378-.066.57-.066C13.806 4.667 15 5.86 15 7.333 15 8.806 13.806 10 12.333 10H11c-.368 0-.667.298-.667.667 0 .368.299.666.667.666h1.333c2.21-.054 3.956-1.889 3.902-4.098-.054-2.21-1.89-3.956-4.098-3.902z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.333 7.333c-.368 0-.666.299-.666.667v5.723l-.864-.86c-.264-.226-.658-.211-.905.035-.246.247-.261.64-.035.905l2 2c.26.259.68.259.94 0l2-2c.227-.264.212-.658-.035-.905-.246-.246-.64-.261-.905-.035l-.863.86V8c0-.368-.298-.667-.667-.667z"
});

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#FFF",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.506f9ea6.svg";
export { ForwardRef as ReactComponent };